<!-- Chat Container -->
<div class="chat-container">
  <!-- Header -->
  <div class="chat-header">
    <div class="connection-status">
      <span class="status-icon">{{ getConnectionStatusIcon() }}</span>
      <span class="status-text">{{ getConnectionStatusText() }}</span>
    </div>
    
    <div class="proximity-controls" *ngIf="!isProximityEnabled">
      <button 
        class="btn btn-primary"
        (click)="enableProximityNotifications()"
        [disabled]="isLoading">
        📡 Habilitar Proximidad
      </button>
    </div>

    <div class="proximity-controls" *ngIf="isProximityEnabled">
      <button 
        class="btn btn-success"
        (click)="joinProximityChat()"
        [disabled]="isLoading">
        💬 Chat de Proximidad
      </button>
      <button 
        class="btn btn-outline"
        (click)="disableProximityNotifications()">
        🚫 Deshabilitar
      </button>
    </div>
  </div>

  <div class="chat-content">
    <!-- Sidebar con rooms activos -->
    <div class="rooms-sidebar" [class.collapsed]="activeRooms.length === 0">
      <div class="rooms-header">
        <h3>Chats Activos</h3>
        <span class="rooms-count">({{ activeRooms.length }})</span>
      </div>

      <div class="rooms-list">
        <div 
          *ngFor="let room of activeRooms" 
          class="room-item"
          [class.selected]="selectedRoom?.id === room.id"
          [class.unread]="room.unreadCount > 0"
          (click)="selectRoom(room)">
          
          <div class="room-info">
            <div class="room-name">
              <span class="room-type-icon">
                {{ room.type === 'proximity' ? '📍' : room.type === 'place' ? '🏢' : '💬' }}
              </span>
              {{ room.name }}
            </div>
            
            <div class="room-details">
              <span class="participants-count">
                👥 {{ getRoomParticipantCount(room) }}
              </span>
              <span class="unread-count" *ngIf="room.unreadCount > 0">
                {{ room.unreadCount }}
              </span>
            </div>
          </div>

          <div class="room-last-message" *ngIf="room.lastMessage">
            <div class="last-message-content">
              {{ room.lastMessage.content }}
            </div>
            <div class="last-message-time">
              {{ formatTimestamp(room.lastMessage.timestamp) }}
            </div>
          </div>

          <button 
            class="leave-room-btn"
            (click)="leaveRoom(room); $event.stopPropagation()"
            title="Salir del chat">
            ❌
          </button>
        </div>
      </div>

      <!-- Mensaje cuando no hay rooms -->
      <div class="no-rooms" *ngIf="activeRooms.length === 0">
        <p>No hay chats activos</p>
        <p>Únete al chat de proximidad para comenzar</p>
      </div>
    </div>

    <!-- Main chat area -->
    <div class="chat-main" [class.no-room-selected]="!selectedRoom">
      
      <!-- Room header -->
      <div class="room-header" *ngIf="selectedRoom">
        <div class="room-info">
          <h3>
            <span class="room-type-icon">
              {{ selectedRoom.type === 'proximity' ? '📍' : selectedRoom.type === 'place' ? '🏢' : '💬' }}
            </span>
            {{ selectedRoom.name }}
          </h3>
          <div class="room-participants">
            👥 {{ getRoomParticipantCount(selectedRoom) }} participantes
          </div>
        </div>
      </div>

      <!-- Messages area -->
      <div 
        class="messages-container" 
        *ngIf="selectedRoom"
        #messagesContainer>
        
        <div class="loading" *ngIf="isLoading">
          <div class="spinner"></div>
          <span>Cargando mensajes...</span>
        </div>

        <div 
          *ngFor="let message of messages" 
          class="message"
          [class.own-message]="message.isOwn"
          [class.other-message]="!message.isOwn">
          
          <div class="message-header" *ngIf="!message.isOwn">
            <div class="user-info">
              <span class="user-name">{{ message.userInfo.name }}</span>
              <span class="user-validation">
                {{ message.userInfo.validation_level > 1 ? '✅' : '' }}
              </span>
            </div>
          </div>

          <div class="message-content">
            {{ message.content }}
          </div>

          <div class="message-timestamp">
            {{ formatTimestamp(message.timestamp) }}
          </div>
        </div>

        <!-- No messages placeholder -->
        <div class="no-messages" *ngIf="messages.length === 0 && !isLoading">
          <p>No hay mensajes aún</p>
          <p>¡Sé el primero en escribir algo!</p>
        </div>
      </div>

      <!-- Message input -->
      <div class="message-input-container" *ngIf="selectedRoom">
        <div class="message-input">
          <textarea
            [(ngModel)]="currentMessage"
            placeholder="Escribe tu mensaje..."
            (keypress)="onKeyPress($event)"
            [disabled]="!isConnected"
            rows="1"
            maxlength="500"></textarea>
          
          <button 
            class="send-button"
            (click)="sendMessage()"
            [disabled]="!isConnected || !currentMessage.trim()"
            title="Enviar mensaje (Enter)">
            📤
          </button>
        </div>
        
        <div class="input-info">
          <span class="char-counter">{{ currentMessage.length }}/500</span>
          <span class="connection-hint" *ngIf="!isConnected">
            ⚠️ Sin conexión
          </span>
        </div>
      </div>

      <!-- No room selected placeholder -->
      <div class="no-room-placeholder" *ngIf="!selectedRoom">
        <div class="placeholder-content">
          <h3>💬 Bienvenido al Chat</h3>
          <p>Selecciona un chat de la lista o únete al chat de proximidad para comenzar a conversar con personas cercanas.</p>
          
          <div class="placeholder-actions" *ngIf="!isProximityEnabled">
            <button 
              class="btn btn-primary btn-large"
              (click)="enableProximityNotifications()"
              [disabled]="isLoading">
              📡 Habilitar Chat de Proximidad
            </button>
          </div>

          <div class="placeholder-actions" *ngIf="isProximityEnabled">
            <button 
              class="btn btn-success btn-large"
              (click)="joinProximityChat()"
              [disabled]="isLoading">
              💬 Unirse a Chat de Proximidad
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>